import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already set their cookie preferences
    const cookieConsent = localStorage.getItem('nightmark_cookie_consent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('nightmark_cookie_consent', 'all');
    setIsVisible(false);
    // Here you would typically initialise your analytics scripts
  };

  const handleRejectOptional = () => {
    localStorage.setItem('nightmark_cookie_consent', 'essential_only');
    setIsVisible(false);
    // Ensure tracking scripts are disabled here
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner bg-dark">
      
      {/* MOBILE CSS OVERRIDES FOR COOKIE BANNER */}
      <style>
        {`
          @media (max-width: 768px) {
            .cookie-banner { padding: 1.5rem 1rem; }
            .cookie-container { 
              flex-direction: column; 
              text-align: center; 
              gap: 1.5rem; 
            }
            .cookie-text h4 { font-size: 1.2rem; }
            .cookie-text p { font-size: 0.85rem; line-height: 1.5; }
            .cookie-actions { 
              width: 100%; 
              flex-direction: column; 
              gap: 0.8rem;
            }
            .cookie-actions .btn { width: 100%; }
          }
        `}
      </style>

      <div className="container cookie-container">
        <div className="cookie-text">
          <h4>Your Privacy</h4>
          <p>
            We use cookies to ensure our website functions correctly, analyse site traffic and improve your browsing experience. By clicking 'Accept All', you consent to our use of all cookies. Alternatively, you can choose to reject non-essential cookies. For more information, please read our <Link to="/privacy-policy" className="text-link">Privacy Policy</Link>.
          </p>
        </div>
        <div className="cookie-actions">
          <button onClick={handleRejectOptional} className="btn btn-secondary">
            Reject Optional
          </button>
          <button onClick={handleAcceptAll} className="btn btn-primary">
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;